import { COLORS } from "../theme/colors";
import obStatusStartImg from "../assets/images/icons/obStatusStart.svg";
import obStatusElectricityImg from "../assets/images/icons/connect-status-pending.svg";
import obStatusTenantUnitImg from "../assets/images/icons/connect-status-ready.svg";
import obStatusCompleteImg from "../assets/images/icons/connect-status-connected.svg";

export const MAX_PASS_CHAR_COUNT = 20;
export const MIN_PASS_CHAR_COUNT = 8;
export const SPECIAL_CHARACTER = /[`!@#$%^&*()_+\-=\]{};':"\\|,.<>?~]/;
export const ATLEAST_ONE_UPPERCASE = /.*[A-Z].*/;

export const USER_ROLES = {
  super_pm: "SUPER_PM",
  pm: "MANAGER",
  bop: "OPERATOR",
};

export const STATUS_OB_READY = "ready";
export const STATUS_OB_ALL = {
  key: "all",
  name: "All status",
};

export const ONBOARDING_STATUES = {
  pending: "PENDING",
  electricity_data: "ELECTRICITY_DATA",
  tenant_and_unit_data: "TENANT_AND_UNIT_DATA",
  completed: "COMPLETED",
};

export const BUILDING_STATUSES = {
  [STATUS_OB_READY]: {
    name: "Ready for OB Kick off",
    color: COLORS.darks[0][25],
  },
  pending: {
    name: "Pending (sent to BOP)",
    color: COLORS.darks[0][100],
  },
  electricity_data: {
    name: "Electricity data",
    color: COLORS.lightBlues[0][100],
  },
  tenant_and_unit_data: {
    name: "Tenancy & units data",
    color: COLORS.purple,
  },
  completed: {
    name: "Completed OB",
    color: COLORS.green,
  },
  stand_by: {
    name: "Standby",
    color: COLORS.orange,
  },
  rejected: {
    name: "Rejected",
    color: COLORS.lightPink,
  },
};

export const CARD_VIEWS_STATUSES = {
  pending: {
    name: "Start Building onboarding",
    icon: obStatusStartImg,
  },
  electricity_data: {
    name: "Complete Electricity Data",
    icon: obStatusElectricityImg,
  },
  tenant_and_unit_data: {
    name: "Complete Tenancy & Units Data",
    icon: obStatusTenantUnitImg,
  },
  completed: {
    name: "You’re Done! OB completed",
    icon: obStatusCompleteImg,
  },
};

export const MGMT_COMPANY = "MGMT_COMPANY";
export const CENTRAL = "CENTRAL";
export const SUBMETERS = "SUBMETERS";
export const METER_PER_UNIT = "METER_PER_UNIT";

export const SEGMENTS = [
  { color: COLORS.shadowBlue, name: "Offices" },
  { color: COLORS.olivine, name: "Residential" },
  { color: COLORS.majorelleBlue, name: "Logistics" },
  { color: COLORS.blue, name: "Retail" },
  { color: COLORS.verdigris, name: "Hospitality" },
  { color: COLORS.pearlyPurple, name: "Data centers" },
];
